"use client";

import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/utils/utils";
import Image from "next/image";

interface SidebarToggleButtonProps {
  className?: string;
}

export const SidebarToggleButton = ({ className }: SidebarToggleButtonProps) => {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      data-sidebar="trigger"
      variant="ghost"
      size="icon"
      className={cn(
        "h-7 w-7 shrink-0 rounded-md text-foreground hover:bg-black/[0.04]",
        className,
      )}
      onClick={toggleSidebar}
    >
      <Image
        src="/custom-icons/sidebar-left.svg"
        alt="Toggle sidebar"
        width={15}
        height={15}
        className="size-[15px]"
      />
    </Button>
  );
};
